import Wrapper from "@/components/wrapper"
import { KeyRound } from "lucide-react"

const PW_Card = ({ title, description, children }) => (
  <Wrapper.shadow className="overflow-hidden rounded-2xl border border-slate-200/80 bg-white p-0 shadow-sm">
    <div className="p-5 sm:p-6 md:p-7">
      <div className="flex items-center gap-3">
        <div className="flex size-11 shrink-0 items-center justify-center rounded-xl bg-blue-50 text-toicos-navy">
          <KeyRound size={21} strokeWidth={1.8} />
        </div>

        <div className="min-w-0 flex-1">
          <h2 className="text-base font-bold tracking-tight text-slate-800">{title}</h2>
          <p className="mt-1 text-sm leading-relaxed text-slate-500">{description}</p>
        </div>
      </div>

      <div className="my-6 border-t border-slate-100" />

      {children}
    </div>
  </Wrapper.shadow>
)

export default PW_Card
